export class MicrophoneError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, MicrophoneError.prototype)
  }
}

export class PermissionDenied extends MicrophoneError {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, PermissionDenied.prototype)
  }
}

export class UnexpectedMediaPermissionError extends MicrophoneError {
  constructor() {
    super('Unexpected error occurred please contact support')
    Object.setPrototypeOf(this, UnexpectedMediaPermissionError.prototype)
  }
}

export async function getAudioStream() {
  try {
    return await navigator.mediaDevices.getUserMedia({ audio: true })
  } catch (e) {
    if (e instanceof DOMException) {
      throw new PermissionDenied(getErrorMessage(e))
    }
    throw new UnexpectedMediaPermissionError()
  }
}

function getErrorMessage(domException: DOMException) {
  switch (domException.name) {
    case 'NotAllowedError':
    case 'NotFoundError':
    case 'NotReadableError':
      return 'Please check that access to your microphone is allowed for this website and try again'
    default:
      return 'Cannot access the microphone'
  }
}
